<template>
  <div id="userview" class="viewport">
    <div class="columns">
      <div class="column">
        <h1>Städte</h1>
      </div>
      <div class="column alignRight">
        <button class="button is-pulled-right" v-on:click="newCity">Neue Stadt</button>
        <button class="button is-pulled-right" v-on:click="searchAndReplace">Tel-Nr. suchen/Ersetzen</button>
      </div>
    </div>
    
    <div id="telsearchandreplace" v-if="telsearchandreplace">
      <div class="columns">
        <div class="column">
          <div class="borderround">
              <div class="sarbox">
                <h3>Suchen & Ersetzen</h3>
                <div class="sar-group">
                  <label><input type="radio" v-model="sar.range" value="db"> Ganze DB</label>
                  <label><input type="radio" v-model="sar.range" value="selection"> In Auswahl</label>
                </div>
                <div class="sar-group">
                  <label>Alt <input v-model="sar.searchStr" ></label>
                  <label>Neu <input v-model="sar.replaceStr"></label>
                </div>
                <button class="button" v-on:click="searchAndReplaceLos"><div v-if="!sar.loading" class="desc">Los!</div><i v-if="sar.loading" class="fa fa-spinner fa-pulse"></i></button>
              </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="columns">
      <div class="column">
        <div class="borderround">
          <div class="city head">
            <span class="col id">ID</span>
            <span class="col cityname">Stadt</span>
            <span class="col land">Land</span>    
            <span class="col telephone">Telefon</span>    
          </div>        
          <city :city.sync="city" :key="city.id" v-for="(city, key, index) in cities"></city>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import City from '@/views/Cities/City';  
  export default {

    name: "CitiesView",
    components: {
      City
    },
    data() {
        return {
          cities: [],
          telsearchandreplace: false,
          sar: {
            searchStr: "",
            replaceStr: "",
            range: 'db',
            selectionIDs: [],
            buttonText: '',
            loading: false
          }
        }
    },
    sockets: {
      getCitiesList(r){
          //console.log(r)
          this.cities = []
          this.cities = r
      },
      citySRTelDone(r){
         setTimeout( ()=>{ this.sar.loading = false; this.$socket.emit('getCitiesList') }, 1000)
         
      }
      
    },
    methods: {
      searchAndReplace(e){
        e.preventDefault();
        this.telsearchandreplace = this.telsearchandreplace == true ? false : true;
        
        //this.cities[0].telefon = '1234567'
      },
      searchAndReplaceLos(e){
          e.preventDefault();
          console.log('searchAndReplaceLos')
          this.sar.loading = true
          this.$socket.emit('citySRTel', { update: { sar: this.sar }, quiet: 0 } )
      },
      
      
      newCity(e){
        e.preventDefault();
        this.$router.replace({ name: "CitySingle", params: { cityid: 'new' } })
      }
      
    },
    mounted: function(){
      this.$socket.emit('getCitiesList');
    }
  
  }
</script>
<style>
  .city { display: flex; flex-wrap: wrap; }
  .city .col {
      padding: 0.43333em 0.93333em 0.43333em 0;
      width: 25%;
      flex: 1 1 25%;
    }
  .city .col.id { flex: 1 1 10% }
  .city .col.land { flex: 1 1 15% }
  .city .col.telephone { flex: 1 1 35% }


.city.head .col { font-weight: bold; }
  
  .sarbox { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; }
  .sarbox label { font-size: 1rem; display: inline-block; line-height: 1; padding: 0 0.733333em; white-space: nowrap; }
  .sarbox label input { display: inline; width: auto; vertical-align: baseline; margin-right: 0.333rem;  }
  .sarbox label input[type="text"] {  }
  .sarbox h3 { font-weight: 800; margin: 0 0.73333em 0 0; }
  .sar-group { padding: 0.3333333em 0;}
  .viewport .sarbox .button span { display: inline; }
</style>